export default "__VITE_ASSET__de748463__"